import useFeatureTitles from "ai-management/token-usage/hooks/useFeatureTitles";
import useProviderNames from "ai-management/token-usage/hooks/useProviderNames";
import useModelNames from "ai-management/token-usage/hooks/useModelNames";
const useDisplayName = () => {
  const featureTitle = useFeatureTitles();
  const providerName = useProviderNames();
  const modelName = useModelNames();
  const names = {
    feature_id: featureTitle,
    provider: providerName,
    model: modelName
  };
  return (group) => Object.entries(group).map(([dimension, value]) => {
    var _a, _b;
    return (_b = (_a = names[dimension]) == null ? void 0 : _a.call(names, value)) != null ? _b : value;
  }).join(" \u2014 ");
};
export default useDisplayName;
